import { useSelector } from "react-redux";
import { defaultSettingBailiffSelector } from "store/bailiff/(default)/setting/default_setting.selector";
import Decimal from "decimal.js";
import lodash from "lodash";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useSetting = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const setting = useSelector(defaultSettingBailiffSelector);
  const depositPercent = setting?.depositPercent || 0;
  const perpageMinutes = setting?.perpageMinutes || 0;
  const perpagePrice = setting?.perpagePrice || 0;
  const perpageSecond = new Decimal(perpageMinutes).mul(60).toNumber();
  const ratio = new Decimal(perpagePrice).dividedBy(perpageSecond)?.toNumber();

  // -------------------------- FUNCTION ------------------------
  const durationToPrice = (duration) => {
    const perPageSeconds = new Decimal(perpageMinutes).mul(60).toNumber();
    const perSecondPrice = new Decimal(perpagePrice)
      .div(perPageSeconds)
      .toNumber();
    // totals
    const totalAmount = new Decimal(duration).mul(perSecondPrice).toNumber();
    const totalRounded = ceilToThousand(totalAmount);
    return totalRounded;
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { ratio, depositPercent, durationToPrice };
};

const ceilToThousand = (value) => {
  return lodash.ceil(value, -3);
};
